import React from 'react';
import { Input } from 'antd';
import { AnimatePresence, motion } from 'framer-motion';
import PlacesAutocomplete from 'react-places-autocomplete';
import ShimmerItem from './ShimmerItem';
import { sectionVariants } from './animations';
import { PLACES_DEBOUNCE_MS, PLACES_SEARCH_OPTIONS } from './constants';
import '../../search/assets/css/date-search.css';
import './assets/css/search_fields.css';

const LocationSearchSection = ({
  collapseOpen,
  locationSearchValue,
  handleLocationChange,
  handleLocationSelect,
  handleLocationError,
  locations,
  handleSpecialLocationSelect,
  searchMagnify,
  suggestLocation,
  withAnimation = true,
}) => {
  const content = (
    <div className='section-content'>
      <PlacesAutocomplete
        value={locationSearchValue}
        onChange={handleLocationChange}
        onSelect={handleLocationSelect}
        onError={handleLocationError}
        searchOptions={PLACES_SEARCH_OPTIONS}
        debounce={PLACES_DEBOUNCE_MS}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div className='location-search-container'>
            <Input
              {...getInputProps({
                size: 'large',
                placeholder: 'Enter Location',
                className: 'rounded-input gRegular',
              })}
              prefix={
                <img
                  src={searchMagnify}
                  style={{
                    width: 18,
                    height: 18,
                    marginRight: 10,
                    marginLeft: 10,
                  }}
                  alt='search'
                />
              }
            />
            <div className='location-select'>
              <h4 className='fs-12 gMedium' style={{ marginLeft: 7 }}>
                Search Location
              </h4>
              <div className='list'>
                {/* Always show special locations first */}
                {locations.slice(0, 2).map((loc, i) => (
                  <div
                    key={`special-${i}`}
                    className={`list-item cp ${loc.active ? 'active' : ''}`}
                    onClick={() =>
                      handleSpecialLocationSelect(i === 0 ? 'nearby' : 'abroad')
                    }
                  >
                    <div
                      className={i !== 1 ? 'sb-blue-bg-100' : 'seagreen-bg-200'}
                      style={{
                        padding: 8,
                        borderRadius: 8,
                        marginRight: 12,
                        width: 40,
                        height: 40,
                        textAlign: 'center',
                      }}
                    >
                      <img
                        src={loc.icon}
                        alt='specific-swim'
                        style={{ width: 18, height: 18 }}
                      />
                    </div>
                    <div className='text'>
                      <div className='main'>{loc.title}</div>
                      {loc.subtitle && (
                        <div className='sub'>{loc.subtitle}</div>
                      )}
                    </div>
                  </div>
                ))}

                {/* Show shimmer loading for search results */}
                {loading && locationSearchValue && (
                  <>
                    <ShimmerItem />
                    <ShimmerItem />
                    <ShimmerItem />
                  </>
                )}

                {/* Show top 5 search suggestions */}
                {!loading &&
                  suggestions.slice(0, 5).map((suggestion, i) => (
                    <div
                      key={`suggestion-${i}`}
                      {...getSuggestionItemProps(suggestion, {
                        className: `list-item ${
                          suggestion.active ? 'active' : ''
                        }`,
                      })}
                    >
                      <div
                        className='sb-blue-bg-100'
                        style={{
                          padding: 8,
                          borderRadius: 8,
                          marginRight: 12,
                          width: 40,
                          height: 40,
                          textAlign: 'center',
                        }}
                      >
                        <img
                          src={suggestLocation}
                          alt='location'
                          style={{
                            width: 18,
                            height: 18,
                          }}
                        />
                      </div>
                      <div className='text'>
                        <div className='main'>{suggestion.description}</div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    </div>
  );

  if (!withAnimation) {
    return collapseOpen === 'where' ? content : null;
  }

  return (
    <AnimatePresence>
      {collapseOpen === 'where' && (
        <motion.div
          initial='closed'
          animate='open'
          exit='closed'
          variants={sectionVariants}
          style={{ overflow: 'hidden' }}
        >
          {content}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LocationSearchSection;
